<template>
  <div
    class="status-component"
    :class="{
      'filial-not-connected': isFilialNotConnected,
      'preorder': isPreorder,
    }"
    :style="{ 'background-color': getBackgroundColor }"
  >
    <transition name="fade" :duration="60">
      <div v-show="showDetails" class="details-window">
        <div class="basket-items">
          <span class="label">Товары:</span>
          <span>{{ order.info.fullName }}</span>
        </div>
        <div class="persons">
          <span class="label">Кол-во персон: {{ getPersons }}</span>
        </div>
        <div class="address">
          <span
            class="label"
          >Адрес доставки:
            <span class="font-weight-regular">{{ getAddress }}</span></span>
        </div>
        <div class="delivery-price">
          <span class="label">Стоимость доставки: {{ getDeliveryPrice }}</span>
        </div>
      </div>
    </transition>

    <div
      class="status-content d-flex flex-column justify-space-between"
      @click="openFastOrder"
    >
      <div>
        <div class="d-flex justify-space-between">
          <span class="admission-time">поступил в {{ getCreatedTime }}</span>
          <span class="admission-time">{{ getPreorderTime }}</span>
        </div>
        <div class="order-number-container d-flex justify-space-between">
          <span
            :class="{'long-number': orderNumberLength > 5}"
            class="order-number"
          >
            {{ getOrderNumber }}
          </span>
          <span class="order-date">{{ getTargetDate }}</span>
          <!--          <span class="order-id"> ID {{ order.id }}</span>-->
        </div>
        <div v-if="isPreorder" class="preorder-label">
          Предзаказ
        </div>
      </div>
      <div>
        <span class="order-status">{{ getStatus }}</span>
      </div>
      <div class="icon" :class="status.company">
        <component :is="getIcon" />
      </div>
    </div>
  </div>
</template>

<script>
  import IconYandex from '@/components/icons/aggregators/IconYandex'
  import IconDeliveryClub from '@/components/icons/aggregators/IconDeliveryClub'
  import IconSberMarket from '@/components/icons/aggregators/IconSberMarket'
  import IconChibis from '@/components/icons/aggregators/IconChibis'
  import IconKuper from '@/components/icons/aggregators/IconKuper.vue'

  import IconCallCenterProcessing from '@/components/icons/IconCallCenterProcessing'

  import OrderStatusNewIcon from '@/components/icons/order-status/OrderStatusNewIcon'
  import OrderStatusPreparingIcon from '@/components/icons/order-status/OrderStatusPreparingIcon'
  import OrderStatusCanceledIcon from '@/components/icons/order-status/OrderStatusCanceledIcon'
  import OrderStatusCompletedIcon from '@/components/icons/order-status/OrderStatusCompletedIcon'
  import OrderStatusConfirmIcon from '@/components/icons/order-status/OrderStatusConfirmIcon'
  import OrderStatusAssemblyIcon from '@/components/icons/order-status/OrderStatusAssemblyIcon'
  import OrderStatusInDeliveryIcon from '@/components/icons/order-status/OrderStatusInDeliveryIcon'
  import OrderStatusReadyForIssueIcon from '@/components/icons/order-status/OrderStatusReadyForIssueIcon'

  import {
    formatIsoDateTimeAsShortYearDate,
    formatIsoDateTimeAsTime,
  } from '@/util/date-time-helper'
  import { getCurrency } from '@/util/money'
  import BasketSource from '@/models/enums/BasketSource'
  import editSessionApi from '@/api/order/edit-session'
  import { mapGetters } from 'vuex'
  import OrderStatus from '@/models/enums/OrderStatus'

  export default {
    name: 'Status',
    components: {
      OrderStatusReadyForIssueIcon,
      OrderStatusInDeliveryIcon,
      OrderStatusAssemblyIcon,
      OrderStatusConfirmIcon,
      OrderStatusCompletedIcon,
      OrderStatusCanceledIcon,
      IconYandex,
      IconDeliveryClub,
      IconSberMarket,
      IconChibis,
      OrderStatusPreparingIcon,
      OrderStatusNewIcon,
      IconCallCenterProcessing,
    },
    emits: ['open-fast-order-on-mobile'],
    props: {
      createdAt: {
        type: String,
        default: '',
      },
      status: {
        type: String,
        default: '',
      },
      order: {
        type: Object,
        default: () => {
        },
      },
    },
    data () {
      return {
        showDetails: false,
        statuses: [
          {
            value: 'new',
            title: 'Новый заказ',
            color: '#FF9100',
          },
          {
            value: 'waitPayment',
            title: 'Ожидает оплаты',
            color: '#F4B083',
          },
          {
            value: 'confirm',
            title: 'Новый заказ',
            // title: 'Потверждён',
            color: '#FF9100', // '#faa84b',
            colorPreorder: '#4a4a4a',
          },
          {
            value: 'preparing',
            title: 'Готовится',
            color: '#38B2B2',
          },
          {
            value: 'assembly',
            title: 'В сборке',
            color: '#614EE2',
          },
          {
            value: 'readyForIssue',
            title: 'Готов к выдаче',
            color: '#ABDB49',
          },
          {
            value: 'inDelivery',
            title: 'Доставляется',
            color: '#1EBFE9',
          },
          {
            value: 'completed',
            title: 'Завершён',
            color: '#17c970',
            // color: '#1EE984',
          },
          {
            value: 'canceled',
            title: 'Отменен',
            color: '#C9C9C9',
          },
        ],
      }
    },
    computed: {
      ...mapGetters({
        indicateFilialConnectionStatus: 'app/indicateFilialConnectionStatus',
        isCallCenterUser: 'auth/isCallCenterUser',
      }),
      getAddress () {
        return this.order.basket.clientAddress
          ? this.order.basket.clientAddress.street
          : '–'
      },
      getPersons () {
        return this.order.basket ? this.order.basket.persons : '–'
      },
      getDeliveryPrice () {
        if (!this.order.deliveryPrice) {
          return 'Бесплатно'
        }
        return this.order.deliveryPrice + getCurrency()
      },
      getOrderNumber () {
        let orderNumber = `№${
          this.order.formattedCode ? this.order.formattedCode : this.order.code
        }`
        if (this.order.kitchenCell && parseInt(this.order.kitchenCell)) {
          orderNumber += `-${this.order.kitchenCell}`
        }
        if (this.order.courierCell && parseInt(this.order.courierCell)) {
          orderNumber += `-${this.order.courierCell}`
        }
        return orderNumber
      },
      orderNumberLength () {
        return this.getOrderNumber.length
      },
      getTargetDate () {
        return formatIsoDateTimeAsShortYearDate(this.order.workDay)
      },
      getCreatedTime () {
        return formatIsoDateTimeAsTime(this.createdAt)
      },
      getStatusItem () {
        return this.statuses.find((item) => item.value === this.status)
      },
      getStatus () {
        if (this.status) {
          const status = this.statuses.find((item) => item.value === this.status)
          return status.title
        }
        return '–'
      },
      getBasketSource () {
        return this.order.basket ? this.order.basket.basketSource : ''
      },
      getIcon () {
        if (this.order?.activeCall) {
          return 'icon-call-center-processing'
        }

        switch (this.getBasketSource) {
          case BasketSource.Yandex:
            return IconYandex
          case BasketSource.DeliveryClub:
            return IconDeliveryClub
          case BasketSource.SberMarket:
            return IconKuper
          case BasketSource.Chibis:
            return IconChibis
        }

        return `order-status-${this.order.orderStatus}-icon`
      },
      getBackgroundColor () {
        if (this.order?.activeCall) {
          return '#DBDFE6'
        }
        if (this.isPreorder && this.getStatusItem?.colorPreorder) {
          return this.getStatusItem?.colorPreorder
        }
        return this.getStatusItem?.color
      },
      isPreorder () {
        return (
          this.order.basket &&
          this.order.basket.toDatetime &&
          this.order.basket.dateDelivery
        )
      },
      getPreorderTime () {
        if (this.isPreorder) {
          return 'на ' + formatIsoDateTimeAsTime(this.order.basket.dateDelivery)
        }
        return ''
      },
      isFilialNotConnected () {
        return (
          this.indicateFilialConnectionStatus &&
          this.isCallCenterUser &&
          this.order?.filial?.isConnected === false
        )
      },
    },
    methods: {
      openFastOrder () {
        if (!this.isMobileScreen) {
          editSessionApi.open(this.order.id)
          this.$router.push({
            path: '/fast-order',
            query: {
              id: this.order.id,
            },
          })
        } else {
          this.$emit('open-fast-order-on-mobile')
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.status-component {
  background-color: @color-primary;
  display: inline-block;
  padding: 14px 10px 12px;
  min-width: 195px;
  position: relative;
  z-index: 1;
  cursor: pointer;
  max-width: 195px;

  &.filial-not-connected {
    //box-shadow: inset 0 0 3px 4px @color-pink;
    box-shadow: inset 0 0 0 3px @color-pink;
  }

  &.preorder {
    border-left: 8px solid #e91d63;
    /*&:after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 6px;
      background-color: #e91d63;
      z-index: 0;
    }*/
  }

  .media-xl({
    max-width: 240px;
    min-width: 240px;
    padding: 18px 12px 15px;
  });

  .label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
  }

  .details-window {
    position: absolute;
    cursor: default;
    top: 0;
    bottom: 0;
    left: calc(100% + 10px);
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 3px 6px #00000029;
    border: 1px solid rgba(0, 0, 0, 0.1);
    min-width: 350px;
    width: 100%;
    padding: 20px;
    z-index: 1;
    overflow-y: auto;

    &:after {
      content: '';
      position: absolute;
      right: 100%;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 10px;
      height: 10px;
      border: 10px solid;
      background-color: red;
      border-color: transparent #ffffff transparent transparent;
      z-index: 2;
    }

    .basket-items {
      margin-bottom: 5px;
    }
  }

  .admission-time {
    display: block;
    margin-bottom: 5px;
    font-size: 11px;
    line-height: 1.2;
    color: #ffffff;
    .media-xl({
      font-size: 14px;
    });
  }

  .status-content {
    min-height: 129px;
  }

  .order-number {
    display: block;
    color: #fff;
    font-size: 24px;
    line-height: 1;

    &.long-number {
      font-size: 20px;
    }

    .media-xl({
      font-size: 29px;
      &.long-number {
        font-size: 24px;
      }
    });

  }

  .preorder-label {
    color: #fff;
    text-transform: uppercase;
    font-weight: bold;
    padding-top: 4px;
    font-size: 12px;
    .media-xl({
      font-size: 14px;
    });
  }

  .order-number-container {
    //margin-bottom: 54px;
    flex-wrap: wrap;
  }

  .order-id {
    color: rgba(255, 255, 255, 0.9);
    font-size: 12px;
  }

  .order-date {
    color: rgba(255, 255, 255, 0.9);
    font-size: 12px;
    font-weight: 500;
    .media-xl({
      font-size: 14px;
    });
  }

  .order-status {
    display: block;
    font-size: 20px;
    line-height: 1;
    color: #ffffff;
    .media-xl({
      font-size: 25px;
    });
  }

  .icon {
    position: absolute;
    right: 15px;
    bottom: 10px;
    z-index: -1;

    &:not(.delivery):not(.yandex) {
      svg {
        &::v-deep {
          .fill-svg(rgba(255, 255, 255, 0.4));
        }
      }
    }

    .media-xl({
      right: 20px;
      bottom: 20px;
    });
  }

  .media-lg({
    width: 50%;
    min-width: 50%;

    .order-number {
      font-size: 18px;
      line-height: 1;
    }
  });
}
</style>
